import styled from "styled-components";

export const PageTitle = styled.h1``;

export const SectionTitle = styled.h3``;

export const Paragraph = styled.p`
  line-height: 2em;
`;
